<template>
  <v-card class="mb-4">
    <v-card-title>Fatturato mensile per anno</v-card-title>
    <v-card-text>
      <apexchart
          type="bar"
          height="380"
          :options="chartOptions"
          :series="chartSeries"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'ReservationAmountByMonth',
  components: { apexchart: VueApexCharts },
  props: { filters: Object },
  data() {
    return {
      chartSeries: [],
      chartOptions: {
        chart: {
          id: 'reservation-amount-by-month',
          toolbar: { show: true },
          stacked: false
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            dataLabels: {
              position: 'top'
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => (val == null ? '' : `${val.toFixed(0)} €`),
          offsetY: -18,
          background: {
            enabled: true,
            foreColor: '#111827',
            borderRadius: 4,
            padding: 2,
            opacity: 0.9
          },
          style: { fontSize: '12px' }
        },
        stroke: { show: true, width: 1 },
        xaxis: {
          categories: [], // impostate da fetch
          title: { text: '' }
        },
        yaxis: {
          title: { text: '€' },
          labels: {
            formatter: (v) => `${Math.round(v)} €`
          }
        },
        tooltip: {
          y: { formatter: (v) => `${v.toFixed(2)} €` }
        },
        legend: {
          position: 'right'
        },
        // palette stile immagine: 2022 blu scuro, 2023 rosso, 2024 verde, 2025 azzurro
        colors: ['#0B1F53', '#C62828', '#10B981', '#22C1DC']
      }
    };
  },
  watch: {
    filters: {
      deep: true,
      immediate: true,
      handler(newFilters) {
        this.fetchData(newFilters);
      }
    }
  },
  methods: {
    async fetchData(filters) {
      const res = await this.$store.dispatch('analytics/getReservationAmountByMonth', filters);
      this.chartSeries = res.series;
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: { ...this.chartOptions.xaxis, categories: res.categories }
      };
    }
  }
};
</script>
